<template>
  <footer class="footer__wrapper">
    <div class="footer__container">
      <a-icon
        :icon="$options.consts.ICON.FMG_LOGO"
        width="auto"
        height="auto"
        :no-hover="true"
        class="footer__main-logo"
      />

      <footer-socials class="footer__socials" />

      <footer-terms />
    </div>
  </footer>
</template>

<script>
import AIcon, { ICON } from 'shared/AIcon/index.vue'
import FooterTerms from '@/components/_layout/AFooter/FooterTerms/index.vue'
import FooterSocials from '@/components/_layout/AFooter/FooterSocials/index.vue'

export default {
  name: 'AFooter',
  components: { FooterSocials, FooterTerms, AIcon },
  consts: {
    ICON
  }
}
</script>

<style lang="scss" scoped>
.footer__wrapper {
  background-color: $c--gray-footer-background;

  $margin-x: (
    $above-desktop-xl: -#{$padding-x-desktop-full-hd},
    $desktop-sm: -#{$padding-x-desktop-sm},
    $mobile: -#{$padding-x-mobile}
  );

  $margin-top: (
    $above-desktop-xl: 85px,
    $desktop-sm: 30px
  );

  $padding: (
    $above-desktop-xl: 60px $padding-x-desktop-full-hd 70px,
    $desktop-sm: 52px $padding-x-desktop-sm 20px,
    $mobile: 22px $padding-x-mobile 25px
  );

  @include setStyleByBreakpoint('margin-top', $margin-top);
  @include setStyleByBreakpoint('margin-left', $margin-x);
  @include setStyleByBreakpoint('margin-right', $margin-x);
  @include setStyleByBreakpoint('padding', $padding);

  .footer__container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    @include mobile {
      padding: 0 25px;
    }
  }

  .footer__main-logo {
    $width: (
      $above-desktop-xl: 180px,
      $desktop-sm: 140px,
      $mobile: 112px
    );

    $height: (
      $above-desktop-xl: 73px,
      $desktop-sm: 57px,
      $mobile: 45px
    );

    @include setStyleByBreakpoint('width', $width);
    @include setStyleByBreakpoint('height', $height);
  }

  .footer__socials {
    $margin-top: (
      $above-desktop-xl: 25px,
      $desktop-sm: 10px,
      $mobile: 15px
    );

    @include setStyleByBreakpoint('margin-top', $margin-top);
  }
}
</style>
